angular.module('impactx.util').filter('trusted',
    function($sce) {
        return function(html) {
            return $sce.trustAsHtml(html)
        };
    }
);